module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-v2-5685b79dffffe2a88929b47088b2b7a0.png";